import styled from 'styled-components';

const StyledDialogContent = styled.div`
  padding: 8px;
  margin: ${({ theme }) => theme.spacingSize.l} 0;
  font-size: ${({ theme }) => theme.smallFontSize};
  overflow: hidden auto;
`;
export default StyledDialogContent;
